module.exports = __webpack_public_path__ + "static/media/icon.heart.19e02b28.svg";